import type {ComponentPropsWithoutRef} from 'react';

type Props = Omit<ComponentPropsWithoutRef<'a'>, 'target' | 'rel'> & {
  readonly isExternal?: boolean;
};

export function Link({isExternal = false, children, ...props}: Props) {
  return (
    // eslint-disable-next-line react-js/jsx-no-target-blank
    <a
      {...(isExternal && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
      {...props}
    >
      {children}
    </a>
  );
}
